import React, { useState } from "react";

import { useGetDataInfoRange } from "api/api-hooks/datasets-hooks";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import { useCompanyTimezone } from "hooks/useTimezone";
import GridHeatmapChart from "./GridHeatmapChart";
import { defaultFromDateTime, defaultToDateTime, shouldShowTime } from "../charts/utils";
import { IGridHeatmapEditorProps } from "./GridHeatmapTypes";

export default function GridHeatmap(props: IGridHeatmapEditorProps) {
  const companyTz = useCompanyTimezone();

  const [dateFrom, setDateFrom] = useState(
    props.start ||
      defaultFromDateTime({
        zoneId: companyTz,
        loadConf: {
          alignUnit: "MINUTES",
          lag: 6,
          lagUnit: "HOURS",
          lead: 0,
          leadUnit: "HOURS",
          ...props.loadConf,
        },
      })
  );

  const [dateTo, setDateTo] = useState(
    props.end ||
      defaultToDateTime({
        zoneId: companyTz,
        loadConf: {
          alignUnit: "MINUTES",
          lag: 6,
          lagUnit: "HOURS",
          lead: 0,
          leadUnit: "HOURS",
          ...props.loadConf,
        },
      })
  );

  const { data } = useGetDataInfoRange(
    props.yAxisSecondary?.identifier
      ? [props.xAxis.identifier, props.yAxis.identifier, props.yAxisSecondary?.identifier]
      : [props.xAxis.identifier, props.yAxis.identifier],
    {
      timeStart: dateFrom?.toISOString() ?? new Date().toISOString(),
      timeEnd: dateTo?.toISOString(),
    }
  );
  return (
    <>
      {!props.hideHeader && (
        <div className="flex flex-row gap-3">
          <CalendarWrapper
            value={dateFrom}
            showTime={shouldShowTime(props.loadConf)}
            onChange={e => {
              setDateFrom(e);
            }}
            dateFormat="yy-mm-dd"
          />
          <CalendarWrapper
            value={dateTo}
            showTime={shouldShowTime(props.loadConf)}
            onChange={e => {
              setDateTo(e);
            }}
            dateFormat="yy-mm-dd"
          />
        </div>
      )}
      {data && <GridHeatmapChart data={data} {...props} />}
    </>
  );
}
